import {Grid, Card, CardContent, Typography, Theme, Skeleton} from '@mui/material';
import {makeStyles} from '@mui/styles';
import FolderIcon from 'components/icons/Folder';
import {DeleteIconButton, EditIconButton} from 'components/buttons';
import {AVATAR_SIZE} from '../AdminBookmarkCard';
import {SVG_VIEWBOX_OFFSET} from 'constants/offsets';

const useStyles = makeStyles((theme : Theme) => ({
  card: {
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.up('lg')]: {
      maxHeight: 117,
    }
  },
  cardContent: {
    width: '100%',
    [theme.breakpoints.up('lg')]: {
      maxHeight: 117,
    }
  },
  avatar: {
    width: AVATAR_SIZE + SVG_VIEWBOX_OFFSET,
    height: AVATAR_SIZE + SVG_VIEWBOX_OFFSET,
    marginLeft: -8,
    '& > svg': {
      filter: `drop-shadow(0px 0.5px 1px rgba(0,0,0,0.5))`,
      width: AVATAR_SIZE,
      height: AVATAR_SIZE,
    }
  },
  name: {
    fontWeight: '500',
  }
}), {name: 'AdminBookmarkFolderCardSkeleton'});

const AdminBookmarkFolderCardSkeleton = () => {
  const classes = useStyles();
  return (
    <Card className={classes.card}>
      <CardContent className={classes.cardContent}>
        <Grid container wrap='nowrap' spacing={2} alignItems='center'>
          <Grid item>
            <FolderIcon className={classes.avatar + ' pulse-animation'} htmlColor='rgba(0, 0, 0, 0.11)' />
          </Grid>
          <Grid item xxs zeroMinWidth>
            <Grid container spacing={1}>
              <Grid item zeroMinWidth xs={12}>
                <Typography className={classes.name} variant='h5' noWrap>
                  <Skeleton />
                </Typography>
              </Grid>
              <Grid item zeroMinWidth xs={12}>
                <Typography variant='body2' noWrap>
                  <Skeleton />
                </Typography>
              </Grid>
              <Grid item zeroMinWidth xs={12}>
                <Grid container spacing={1} justifyContent='flex-end'>
                  <Grid item>
                    <EditIconButton disabled />
                  </Grid>
                  <Grid item>
                    <DeleteIconButton disabled />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default AdminBookmarkFolderCardSkeleton;